<template>
	<div class="pt-3">
			<!-- <h2 class="title-3 text-grey-900 w-100 pb-4">
				{{ content.station_whereIsLocated }}
			</h2> -->
		<div class="map-container d-flex justify-content-center align-items-center" :style="{
			'background-image': `url(${mapPlaceHolder})`
		}"
			style="width: 100%; height: 400px; border-radius: 20px">
			<div class="open-map-container col-md-6 col-10 bg-primary-white d-flex flex-column align-items-center gap-3">
				<div class="title-3 text-grey-900 mt-1 col-12">
					{{ content['map_location_accommodation'] }} {{ lihe?.name || "" }}
				</div>
				<button @click="handleOpenMapClick" type="button" class="button-secondary bg-none border-primary-blue text-primary-blue d-flex justify-content-evenly open-map-button col-md-4 col-12">
					<div class="buttons-small text-primary-blue mt-1">
						{{ content['map_seeMap'] }}
					</div>
					<div>
						<svg style="height: 24px; width: 24px" class="icon tf-icon-16  text-blue-900"> <use xlink:href="#___icon___marker"></use> </svg>
					</div>
				</button>
			</div>
				
		</div>
		<MapComponent v-if="isMapOpen" />
	</div>
</template>

<script lang="ts" setup>
// Vue
import { ref, onMounted} from "vue";
// components
import MapComponent from "@/vue/map/components/map-v2.vue";

// Images
import mapPlaceHolder from "@/images/mapPlaceHolder.png"

// Refs
const isMapOpen = ref(false);

// Handlers
const handleOpenMapClick = (): void => {
	isMapOpen.value = true
	window.dispatchEvent(new Event("openMapClick"))
}

const content = window.content
const lihe = window.lihe

onMounted(() => {
	document.addEventListener("fullscreenchange", () => {
     // if we're no longer in fullscreen, hide the map component
     if (!document.fullscreenElement) {
       isMapOpen.value = false;
     }
   });
 });

</script>

<style>
.vue-map-container .vue-map  {
	border-radius: 20px;
}

.map-container {
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover; 
}
.open-map-container {
	padding: 25px 31px 25px 31px;
	border-radius: 16px;
	border: 1px;

}

.open-map-button {
	padding: 5px !important;
}
</style>
